import React from "react";

const Subtitle = (props) => (
  <div className="py-2 subtitle text-center">{props.children}</div>
);

export default Subtitle;
